import axios from 'axios';
import { getBackendBaseUrl } from '../lib/backendUrl';
import { setAuthNotice, SESSION_ENDED_NOTICE } from '../lib/authNotice';

const API_BASE_URL = getBackendBaseUrl();

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/v1`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('inspire_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A stale/expired/invalid token must never look "logged in" to the app —
// clear it and force back to login on any 401, except the login calls
// themselves (those 401s mean "wrong password", handled by the caller).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/login');
    if (error.response?.status === 401 && !isLoginRequest && !error.config?.skipAuthRedirect) {
      localStorage.removeItem('inspire_token');
      localStorage.removeItem('inspire_user');
      setAuthNotice(SESSION_ENDED_NOTICE);
      if (window.location.pathname !== '/login/faculty') {
        window.location.href = '/login/faculty';
      }
    }
    return Promise.reject(error);
  }
);

export const facultyApi = {
  getAll: (params = {}) => api.get('/faculty', { params }),
  
  getById: (id) => api.get(`/faculty/${id}`),
  
  create: (data) => api.post('/admin/faculty', data),
  createAsAdmin: (data) => api.post('/admin/faculty', data),
  
  update: (id, data) => api.patch(`/faculty/${id}`, data),
  
  deactivate: (id) => api.patch(`/faculty/${id}/deactivate`),
  
  getAvailability: (id) => api.get(`/faculty/${id}/availability`),
  
  addAvailability: (id, data) => api.post(`/faculty/${id}/availability`, data),
  
  deleteAvailability: (id) => api.delete(`/faculty/availability/${id}`),
  
  delete: (id) => api.delete(`/admin/faculty/${id}`),

  reactivate: (id) => api.patch(`/admin/faculty/${id}/reactivate`),

  resetPassword: (id, data) => api.post(`/admin/faculty/${id}/reset-password`, data),
};

export default api;
